import { Routes } from "@angular/router";
import { BehkhaanRoutes } from "@shared/utils/router-paths";

export const DonationRoutes: Routes = [
    {
        path: BehkhaanRoutes.Donation.pre,
        loadComponent: () =>
            import("../../pre-donation/pre-donation.component").then(
                (c) => c.PreDonationComponent
            ),
    },
    {
        path: BehkhaanRoutes.Donation.donation,
        loadComponent: () =>
            import("../../pre-donation/presentors/donate/donate.component").then(
                (c) => c.DonateComponent
            ),
    },
    {
        path: BehkhaanRoutes.Donation.result + '/:id',
        loadComponent: () =>
            import("../presentors/donation result/donation-result.component").then(
                (c) => c.DonationResultComponent
            ),
    },
]